// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.export-cols-modal {
  min-width: 0;
  color: #243447;
}

.export-cols-modal__header {
  border-bottom: 1px solid #e8eef4;
  padding: 1.1rem 1.35rem 0.9rem;
}

.export-cols-modal__body {
  padding: 0.85rem 1.35rem 1rem;
}

.export-cols-modal__lead {
  margin: 0 0 1rem;
  font-size: 0.875rem;
  line-height: 1.45;
  color: #5b6b7c;
}

.export-cols-modal__format {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.65rem;
  margin-bottom: 1.15rem;
}

@media (max-width: 480px) {
  .export-cols-modal__format {
    grid-template-columns: 1fr;
  }
}
.export-cols-modal__fmt {
  position: relative;
  display: flex;
  align-items: center;
  gap: 0.7rem;
  width: 100%;
  margin: 0;
  padding: 0.85rem 0.9rem;
  text-align: left;
  border: 1.5px solid #d5dee8;
  border-radius: 12px;
  background: #fff;
  cursor: pointer;
  transition: border-color 0.18s ease, background 0.18s ease, box-shadow 0.18s ease, transform 0.18s ease;
}
.export-cols-modal__fmt:hover:not(.is-on) {
  border-color: #b7c6d6;
  background: #f8fafc;
}
.export-cols-modal__fmt:focus {
  outline: none;
}
.export-cols-modal__fmt:focus-visible {
  box-shadow: 0 0 0 3px rgba(15, 76, 129, 0.18);
}
.export-cols-modal__fmt.is-on {
  transform: translateY(-1px);
  box-shadow: 0 6px 16px rgba(15, 40, 70, 0.08);
}

.export-cols-modal__fmt--excel.is-on {
  border-color: #1f7a4d;
  background: linear-gradient(180deg, #f3faf6 0%, #fff 100%);
}
.export-cols-modal__fmt--excel.is-on .export-cols-modal__fmt-icon {
  background: #1f7a4d;
  color: #fff;
  box-shadow: 0 4px 10px rgba(31, 122, 77, 0.28);
}
.export-cols-modal__fmt--excel.is-on .export-cols-modal__fmt-radio {
  border-color: #1f7a4d;
  background: #1f7a4d;
}
.export-cols-modal__fmt--excel.is-on .export-cols-modal__fmt-radio::after {
  opacity: 1;
  transform: scale(1);
}

.export-cols-modal__fmt--pdf.is-on {
  border-color: #c0392b;
  background: linear-gradient(180deg, #fdf5f4 0%, #fff 100%);
}
.export-cols-modal__fmt--pdf.is-on .export-cols-modal__fmt-icon {
  background: #c0392b;
  color: #fff;
  box-shadow: 0 4px 10px rgba(192, 57, 43, 0.28);
}
.export-cols-modal__fmt--pdf.is-on .export-cols-modal__fmt-radio {
  border-color: #c0392b;
  background: #c0392b;
}
.export-cols-modal__fmt--pdf.is-on .export-cols-modal__fmt-radio::after {
  opacity: 1;
  transform: scale(1);
}

.export-cols-modal__fmt-icon {
  flex: 0 0 auto;
  width: 2.35rem;
  height: 2.35rem;
  border-radius: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #eef3f8;
  color: #5b6b7c;
  font-size: 1.15rem;
  transition: background 0.18s ease, color 0.18s ease, box-shadow 0.18s ease;
}

.export-cols-modal__fmt-copy {
  flex: 1 1 auto;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 0.12rem;
}
.export-cols-modal__fmt-copy strong {
  font-size: 0.9rem;
  font-weight: 700;
  color: #1a2b3c;
  line-height: 1.2;
}
.export-cols-modal__fmt-copy small {
  font-size: 0.72rem;
  color: #6b7c8d;
  line-height: 1.3;
}

.export-cols-modal__fmt-radio {
  flex: 0 0 auto;
  width: 1.05rem;
  height: 1.05rem;
  border-radius: 50%;
  border: 2px solid #b7c6d6;
  background: #fff;
  position: relative;
  transition: border-color 0.18s ease, background 0.18s ease;
}
.export-cols-modal__fmt-radio::after {
  content: "";
  position: absolute;
  inset: 0.18rem;
  border-radius: 50%;
  background: #fff;
  opacity: 0;
  transform: scale(0.6);
  transition: opacity 0.15s ease, transform 0.15s ease;
}

.export-cols-modal__toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem 1rem;
  margin-bottom: 0.65rem;
}

.export-cols-modal__search {
  flex: 1 1 12rem;
  max-width: 18rem;
  font-size: 0.875rem;
  border-color: #cfd9e3;
}

.export-cols-modal__meta {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.65rem;
  font-size: 0.8125rem;
  color: #5b6b7c;
}
.export-cols-modal__meta .btn-link {
  font-size: 0.8125rem;
  font-weight: 600;
  color: #0f4c81;
  line-height: 1.2;
}
.export-cols-modal__meta .btn-link:hover {
  text-decoration: underline;
}

.export-cols-modal__lists {
  max-height: min(42vh, 20rem);
  overflow: auto;
  padding-right: 0.15rem;
}

.export-cols-modal__group + .export-cols-modal__group {
  margin-top: 1rem;
  padding-top: 0.85rem;
  border-top: 1px solid #e8eef4;
}

.export-cols-modal__group-head {
  margin-bottom: 0.45rem;
}

.export-cols-modal__group-toggle {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  margin: 0;
  cursor: pointer;
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  color: #5b6b7c;
}
.export-cols-modal__group-toggle input {
  margin: 0;
}

.export-cols-modal__grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  -moz-column-gap: 1.25rem;
       column-gap: 1.25rem;
  row-gap: 0;
  align-items: start;
}

.export-cols-modal__col {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

@media (max-width: 576px) {
  .export-cols-modal__grid {
    grid-template-columns: 1fr;
  }
}
.export-cols-modal__field {
  display: flex;
  align-items: flex-start;
  gap: 0.45rem;
  margin: 0;
  padding: 0.35rem 0;
  cursor: pointer;
  font-size: 0.875rem;
  color: #243447;
  min-width: 0;
}
.export-cols-modal__field input {
  margin-top: 0.2rem;
  flex-shrink: 0;
}
.export-cols-modal__field span {
  line-height: 1.35;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.export-cols-modal__empty {
  margin: 1.25rem 0 0.5rem;
  text-align: center;
  font-size: 0.875rem;
  color: #5b6b7c;
}

.export-cols-modal__footer {
  border-top: 1px solid #e8eef4;
  padding: 0.85rem 1.35rem;
}`, "",{"version":3,"sources":["webpack://./apps/hybrid-app/src/app/features/shared/export-columns-modal/export-columns-modal.component.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,cAAA;AACF;;AAEA;EACE,gCAAA;EACA,8BAAA;AACF;;AAEA;EACE,6BAAA;AACF;;AAEA;EACE,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,cAAA;AACF;;AAEA;EACE,aAAA;EACA,8BAAA;EACA,YAAA;EACA,sBAAA;AACF;;AAEA;EACE;IACE,0BAAA;EACF;AACF;AAEA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,WAAA;EACA,SAAA;EACA,uBAAA;EACA,gBAAA;EACA,2BAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,uGACE;AADJ;AAME;EACE,qBAAA;EACA,mBAAA;AAJJ;AAOE;EACE,aAAA;AALJ;AAQE;EACE,6CAAA;AANJ;AASE;EACE,2BAAA;EACA,6CAAA;AAPJ;;AAYE;EACE,qBAAA;EACA,0DAAA;AATJ;AAWI;EACE,mBAAA;EACA,WAAA;EACA,8CAAA;AATN;AAYI;EACE,qBAAA;EACA,mBAAA;AAVN;AAYM;EACE,UAAA;EACA,mBAAA;AAVR;;AAiBE;EACE,qBAAA;EACA,0DAAA;AAdJ;AAgBI;EACE,mBAAA;EACA,WAAA;EACA,8CAAA;AAdN;AAiBI;EACE,qBAAA;EACA,mBAAA;AAfN;AAiBM;EACE,UAAA;EACA,mBAAA;AAfR;;AAqBA;EACE,cAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,0EAAA;AAlBF;;AAqBA;EACE,cAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;AAlBF;AAoBE;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AAlBJ;AAqBE;EACE,kBAAA;EACA,cAAA;EACA,gBAAA;AAnBJ;;AAuBA;EACE,cAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;EACA,0DAAA;AApBF;AAsBE;EACE,WAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,UAAA;EACA,qBAAA;EACA,oDAAA;AApBJ;;AAwBA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;EACA,sBAAA;AArBF;;AAwBA;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;AArBF;;AAwBA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,YAAA;EACA,oBAAA;EACA,cAAA;AArBF;AAuBE;EACE,oBAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AArBJ;AAuBI;EACE,0BAAA;AArBN;;AA0BA;EACE,4BAAA;EACA,cAAA;EACA,sBAAA;AAvBF;;AA2BE;EACE,gBAAA;EACA,oBAAA;EACA,6BAAA;AAxBJ;;AA4BA;EACE,sBAAA;AAzBF;;AA4BA;EACE,oBAAA;EACA,mBAAA;EACA,WAAA;EACA,SAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAAA;AAzBF;AA2BE;EACE,SAAA;AAzBJ;;AA6BA;EACE,aAAA;EACA,gDAAA;EACA,wBAAA;OAAA,mBAAA;EACA,UAAA;EACA,kBAAA;AA1BF;;AA6BA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AA1BF;;AA6BA;EACE;IACE,0BAAA;EA1BF;AACF;AA6BA;EACE,aAAA;EACA,uBAAA;EACA,YAAA;EACA,SAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;EACA,cAAA;EACA,YAAA;AA3BF;AA6BE;EACE,kBAAA;EACA,cAAA;AA3BJ;AA8BE;EACE,iBAAA;EACA,gBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;AA5BJ;;AAgCA;EACE,wBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;AA7BF;;AAgCA;EACE,6BAAA;EACA,wBAAA;AA7BF","sourcesContent":[".export-cols-modal {\n  min-width: 0;\n  color: #243447;\n}\n\n.export-cols-modal__header {\n  border-bottom: 1px solid #e8eef4;\n  padding: 1.1rem 1.35rem 0.9rem;\n}\n\n.export-cols-modal__body {\n  padding: 0.85rem 1.35rem 1rem;\n}\n\n.export-cols-modal__lead {\n  margin: 0 0 1rem;\n  font-size: 0.875rem;\n  line-height: 1.45;\n  color: #5b6b7c;\n}\n\n.export-cols-modal__format {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 0.65rem;\n  margin-bottom: 1.15rem;\n}\n\n@media (max-width: 480px) {\n  .export-cols-modal__format {\n    grid-template-columns: 1fr;\n  }\n}\n\n.export-cols-modal__fmt {\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 0.7rem;\n  width: 100%;\n  margin: 0;\n  padding: 0.85rem 0.9rem;\n  text-align: left;\n  border: 1.5px solid #d5dee8;\n  border-radius: 12px;\n  background: #fff;\n  cursor: pointer;\n  transition:\n    border-color 0.18s ease,\n    background 0.18s ease,\n    box-shadow 0.18s ease,\n    transform 0.18s ease;\n\n  &:hover:not(.is-on) {\n    border-color: #b7c6d6;\n    background: #f8fafc;\n  }\n\n  &:focus {\n    outline: none;\n  }\n\n  &:focus-visible {\n    box-shadow: 0 0 0 3px rgba(15, 76, 129, 0.18);\n  }\n\n  &.is-on {\n    transform: translateY(-1px);\n    box-shadow: 0 6px 16px rgba(15, 40, 70, 0.08);\n  }\n}\n\n.export-cols-modal__fmt--excel {\n  &.is-on {\n    border-color: #1f7a4d;\n    background: linear-gradient(180deg, #f3faf6 0%, #fff 100%);\n\n    .export-cols-modal__fmt-icon {\n      background: #1f7a4d;\n      color: #fff;\n      box-shadow: 0 4px 10px rgba(31, 122, 77, 0.28);\n    }\n\n    .export-cols-modal__fmt-radio {\n      border-color: #1f7a4d;\n      background: #1f7a4d;\n\n      &::after {\n        opacity: 1;\n        transform: scale(1);\n      }\n    }\n  }\n}\n\n.export-cols-modal__fmt--pdf {\n  &.is-on {\n    border-color: #c0392b;\n    background: linear-gradient(180deg, #fdf5f4 0%, #fff 100%);\n\n    .export-cols-modal__fmt-icon {\n      background: #c0392b;\n      color: #fff;\n      box-shadow: 0 4px 10px rgba(192, 57, 43, 0.28);\n    }\n\n    .export-cols-modal__fmt-radio {\n      border-color: #c0392b;\n      background: #c0392b;\n\n      &::after {\n        opacity: 1;\n        transform: scale(1);\n      }\n    }\n  }\n}\n\n.export-cols-modal__fmt-icon {\n  flex: 0 0 auto;\n  width: 2.35rem;\n  height: 2.35rem;\n  border-radius: 10px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: #eef3f8;\n  color: #5b6b7c;\n  font-size: 1.15rem;\n  transition: background 0.18s ease, color 0.18s ease, box-shadow 0.18s ease;\n}\n\n.export-cols-modal__fmt-copy {\n  flex: 1 1 auto;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.12rem;\n\n  strong {\n    font-size: 0.9rem;\n    font-weight: 700;\n    color: #1a2b3c;\n    line-height: 1.2;\n  }\n\n  small {\n    font-size: 0.72rem;\n    color: #6b7c8d;\n    line-height: 1.3;\n  }\n}\n\n.export-cols-modal__fmt-radio {\n  flex: 0 0 auto;\n  width: 1.05rem;\n  height: 1.05rem;\n  border-radius: 50%;\n  border: 2px solid #b7c6d6;\n  background: #fff;\n  position: relative;\n  transition: border-color 0.18s ease, background 0.18s ease;\n\n  &::after {\n    content: '';\n    position: absolute;\n    inset: 0.18rem;\n    border-radius: 50%;\n    background: #fff;\n    opacity: 0;\n    transform: scale(0.6);\n    transition: opacity 0.15s ease, transform 0.15s ease;\n  }\n}\n\n.export-cols-modal__toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.5rem 1rem;\n  margin-bottom: 0.65rem;\n}\n\n.export-cols-modal__search {\n  flex: 1 1 12rem;\n  max-width: 18rem;\n  font-size: 0.875rem;\n  border-color: #cfd9e3;\n}\n\n.export-cols-modal__meta {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.65rem;\n  font-size: 0.8125rem;\n  color: #5b6b7c;\n\n  .btn-link {\n    font-size: 0.8125rem;\n    font-weight: 600;\n    color: #0f4c81;\n    line-height: 1.2;\n\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n}\n\n.export-cols-modal__lists {\n  max-height: min(42vh, 20rem);\n  overflow: auto;\n  padding-right: 0.15rem;\n}\n\n.export-cols-modal__group {\n  & + & {\n    margin-top: 1rem;\n    padding-top: 0.85rem;\n    border-top: 1px solid #e8eef4;\n  }\n}\n\n.export-cols-modal__group-head {\n  margin-bottom: 0.45rem;\n}\n\n.export-cols-modal__group-toggle {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n  margin: 0;\n  cursor: pointer;\n  font-size: 0.75rem;\n  font-weight: 700;\n  letter-spacing: 0.03em;\n  text-transform: uppercase;\n  color: #5b6b7c;\n\n  input {\n    margin: 0;\n  }\n}\n\n.export-cols-modal__grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  column-gap: 1.25rem;\n  row-gap: 0;\n  align-items: start;\n}\n\n.export-cols-modal__col {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n}\n\n@media (max-width: 576px) {\n  .export-cols-modal__grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n.export-cols-modal__field {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.45rem;\n  margin: 0;\n  padding: 0.35rem 0;\n  cursor: pointer;\n  font-size: 0.875rem;\n  color: #243447;\n  min-width: 0;\n\n  input {\n    margin-top: 0.2rem;\n    flex-shrink: 0;\n  }\n\n  span {\n    line-height: 1.35;\n    overflow: hidden;\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n  }\n}\n\n.export-cols-modal__empty {\n  margin: 1.25rem 0 0.5rem;\n  text-align: center;\n  font-size: 0.875rem;\n  color: #5b6b7c;\n}\n\n.export-cols-modal__footer {\n  border-top: 1px solid #e8eef4;\n  padding: 0.85rem 1.35rem;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
